import clsx from "clsx";
import Modal from "react-responsive-modal";
import Button from "../../../common/button/Button";

export const DeleteRecurringModal = ({ show, onClose }) => {
    return (
        <Modal open={show} onClose={onClose} center>
            <div className="modal-title">Delete Recurring Engagement?</div>
            <div className={clsx("modal-content", "ft-eng-det-del-rec-modal-message")}>Do you want to delete all future occurrences of this engagement?</div>
            <div className="modal-footer">
                <Button view="secondary" text="No" onClick={() => onClose(false)} className={clsx("engagement-button", "ft-eng-det-del-rec-modal-no-btn")} />
                <Button text="Yes" onClick={() => onClose(true)} className={clsx("engagement-button", "ft-eng-det-del-rec-modal-yes-btn")} />
            </div>
        </Modal>
    );
};
